module.exports = __webpack_public_path__ + "static/media/icon-facebook-black.574bbc6d.svg";